export default "__VITE_PUBLIC_ASSET__6376fd01__"